import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-voicemail",
  "use": "icon-voicemail-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-voicemail\" id=\"icon-voicemail\"><circle cx=\"5.5\" cy=\"11.5\" r=\"4.5\" /><circle cx=\"18.5\" cy=\"11.5\" r=\"4.5\" /><line x1=\"5.5\" y1=\"16\" x2=\"18.5\" y2=\"16\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol